import { render, staticRenderFns } from "./VitelGlobal.vue?vue&type=template&id=1ac8c4a0&scoped=true"
import script from "./VitelGlobal.vue?vue&type=script&lang=js"
export * from "./VitelGlobal.vue?vue&type=script&lang=js"
import style0 from "./VitelGlobal.vue?vue&type=style&index=0&id=1ac8c4a0&prod&scoped=true&lang=css"
import style1 from "./VitelGlobal.vue?vue&type=style&index=1&id=1ac8c4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8c4a0",
  null
  
)

export default component.exports